export const AUTH_REQUEST="AUTH_REQUEST";
export const AUTH_SUCCESS="AUTH_SUCCESS";
export const AUTH_FAILURE="AUTH_FAILURE";
export const LOGOUT = "LOGOUT"

export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGIN_FAILURE="LOGIN_FAILURE";